import React from 'react';
import { Icon } from './Icon';

export type Gender = 'male' | 'female' | 'nonbinary';

const GENDER_RING: Record<string, string> = {
  male: 'ring-male',
  female: 'ring-female',
  nonbinary: 'ring-nonbin',
};

export interface AvatarProps {
  name?: string;
  src?: string;
  size?: number;
  gender?: Gender;
  ring?: boolean;
  hue?: number;
}

export function Avatar({
  name = '',
  src,
  size = 38,
  gender,
  ring,
  hue,
}: AvatarProps) {
  const initials = name
    .split(' ')
    .map((w) => w[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
  const cls = ['avatar'];
  if (ring && gender) cls.push(GENDER_RING[gender] || '');
  const bg = hue != null ? `oklch(0.9 0.05 ${hue})` : undefined;
  const fg = hue != null ? `oklch(0.45 0.12 ${hue})` : undefined;
  return (
    <div
      className={cls.join(' ')}
      style={{
        width: size,
        height: size,
        fontSize: size * 0.36,
        background: bg,
        color: fg,
      }}
    >
      {src ? (
        <img
          src={src}
          alt={name}
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      ) : (
        initials
      )}
    </div>
  );
}

export interface GenderIconProps {
  gender?: Gender | string;
  size?: number;
}

const GENDER_MAP: Record<string, [string, string]> = {
  male: ['gender-male', 'var(--g-male)'],
  female: ['gender-female', 'var(--g-female)'],
  nonbinary: ['circle-dashed', 'var(--g-nonbin)'],
};

export function GenderIcon({ gender, size = 15 }: GenderIconProps) {
  const [iconName, color] = (gender && GENDER_MAP[gender]) || [
    'user',
    'var(--text-muted)',
  ];
  return (
    <span style={{ color, display: 'inline-flex' }}>
      <Icon name={iconName as any} size={size} />
    </span>
  );
}

export default Avatar;
